export const REGIONS = {
  pathA: [
    {lat: 53.936775, lng: 14.425968}, // 1 53.936775, 14.425968
    {lat: 54.250338, lng: 16.151233},  // 2 54.250338, 16.151233
    {lat: 53.787296, lng: 15.420825}  // 3 53.787296, 15.420825
  ],

  pathB: [
    {lat: 54.250338, lng: 16.151233},  // 2 54.250338, 16.151233
    {lat: 54.651283, lng: 16.803692}, // 4  54.651283, 16.803692
    {lat: 54.890566, lng: 18.302903}, // 6  54.890566, 18.302903
    {lat: 54.380502, lng: 20.777388}, // 7  54.380502, 20.777388
    {lat: 53.729586, lng: 20.493076}, // 8  53.729586, 20.493076
    {lat: 53.889949, lng: 19.724119}, // 9  53.889949, 19.724119
    {lat: 54.457663, lng: 17.994770}, // 10 54.457663, 17.994770
    {lat: 54.127409, lng: 16.777615} //  11 54.127409, 16.777615
  ],


  pathC: [
    {lat: 51.683232, lng: 16.791380}, //  1 51.683232, 16.791380
    {lat: 51.493815, lng: 17.173155}, //  2 51.493815, 17.173155
    {lat: 51.140189, lng: 17.082518}, //  3 51.140189, 17.082518
    {lat: 51.257221, lng: 16.220091}, //  4 51.257221, 16.220091
  ],

  pathD: [
    {lat: 51.359041, lng: 19.834626}, //  1 51.359041, 19.834626
    {lat: 51.721442, lng: 19.819212}, //  2 51.721442, 19.819212
    {lat: 51.730990, lng: 20.124422}, //  3 51.730990, 20.124422
    {lat: 51.384061, lng: 20.093593}, //  4 51.384061, 20.093593
  ],

  pathE: [
    {lat: 49.412447, lng: 21.231864}, //  1 49.412447, 21.231864
    {lat: 49.683882, lng: 20.834607}, //  2 49.683882, 20.834607
    {lat: 50.066011, lng: 21.549635}, //  3 50.066011, 21.549635
    {lat: 49.830347, lng: 22.177465}, //  4 49.830347, 22.177465
    {lat: 49.187718, lng: 22.020508}, //  5 49.187718, 22.020508
  ],

  pathF: [
    {lat: 54.361568, lng: 20.992050}, // 1   54.361568, 20.992050
    {lat: 53.623402, lng: 20.992050}, // 2   53.623402, 20.992050
    {lat: 53.150415, lng: 18.781257}, // 3   53.150415, 18.781257
    {lat: 53.723608, lng: 17.572046}, // 4   53.723608, 17.572046
    {lat: 53.507030, lng: 15.915015}, // 5   53.507030, 15.915015
    {lat: 53.412804, lng: 14.604186}, // 6   53.412804, 14.604186
    {lat: 52.411193, lng: 14.777210}, // 7   52.411193, 14.777210
    {lat: 51.867497, lng: 15.946851}, // 8   51.867497, 15.946851
    {lat: 52.684751, lng: 16.590499}, // 9   52.684751, 16.590499
    {lat: 52.533452, lng: 17.268753}, // 10  52.533452, 17.268753
    {lat: 50.790755, lng: 18.043899}, // 11  50.790755, 18.043899
    {lat: 50.129875, lng: 18.050820}, // 12  50.129875, 18.050820
    {lat: 50.970026, lng: 15.762604}, // 13  50.970026, 15.762604
    {lat: 51.725680, lng: 14.437502}, // 14  51.725680, 14.437502
    {lat: 54.234186, lng: 13.870019}, // 15  54.234186, 13.870019
    {lat: 53.936775, lng: 14.425968}, // a1  53.936775, 14.425968
    {lat: 53.787296, lng: 15.420825}, // a3  53.787296, 15.420825
    {lat: 54.250338, lng: 16.151233}, // a2  54.250338, 16.151233
    {lat: 54.127409, lng: 16.777615}, // b11 54.127409, 16.777615
    {lat: 54.457663, lng: 17.994770}, // b10 54.457663, 17.994770
    {lat: 53.889949, lng: 19.724119}, // b9  53.889949, 19.724119
    {lat: 53.729586, lng: 20.493076}, // b8  53.729586, 20.493076
    {lat: 54.380502, lng: 20.777388}, // b7  54.380502, 20.777388
  ],

  pathG: [
    {lat: 49.412447, lng: 21.231864}, //  e1 49.412447, 21.231864
    {lat: 49.683882, lng: 20.834607}, //  e2 49.683882, 20.834607
    {lat: 50.066011, lng: 21.549635}, //  e3 50.066011, 21.549635
    {lat: 49.830347, lng: 22.177465}, //  e4 49.830347, 22.177465
    {lat: 49.187718, lng: 22.020508}, //  e5 49.187718, 22.020508
    {lat: 48.877674, lng: 22.933615}, //  1  48.877674, 22.933615
    {lat: 50.162270, lng: 23.476411}, //  2  50.162270, 23.476411
    {lat: 50.809812, lng: 23.171089}, //  3  50.809812, 23.171089
    {lat: 51.569711, lng: 23.202186}, //  4  51.569711, 23.202186
    {lat: 51.919092, lng: 23.774194}, //  5  51.919092, 23.774194
    {lat: 52.477803, lng: 23.566295}, //  6  52.477803, 23.566295
    {lat: 52.783797, lng: 21.447989}, //  7  52.783797, 21.447989
    {lat: 52.337714, lng: 20.007955}, //  8  52.337714, 20.007955
    {lat: 52.615322, lng: 19.036424}, //  9  52.615322, 19.036424
    {lat: 52.445069, lng: 18.380740}, //  10 52.445069, 18.380740
    {lat: 51.391372, lng: 19.047198}, //  11 51.391372, 19.047198
    {lat: 50.552930, lng: 20.443768}, //  12 50.552930, 20.443768
    {lat: 49.182767, lng: 20.915887}, //  13 49.182767, 20.915887
  ],


  pathH: [
    {lat: 54.335516, lng: 21.500840}, //  1 54.335516, 21.500840
    {lat: 54.363227, lng: 22.175984}, //  2 54.363227, 22.175984
    {lat: 53.816671, lng: 22.622910}, //  3 53.816671, 22.622910
    {lat: 53.642279, lng: 23.640381}, //  4 53.642279, 23.640381
    {lat: 53.080495, lng: 23.963689}, //  5 53.080495, 23.963689
    {lat: 53.681721, lng: 22.023839}, //  6 53.681721, 22.023839
  ],

  pathI: [
    {lat: 54.363227, lng: 22.175984}, //  h2 54.363227, 22.175984
    {lat: 53.816671, lng: 22.622910}, //  h3 53.816671, 22.622910
    {lat: 53.642279, lng: 23.640381}, //  h4 53.642279, 23.640381
    {lat: 54.135442, lng: 23.592835}, //     54.135442, 23.592835
    {lat: 54.490459, lng: 22.955728}, //     54.490459, 22.955728
  ],

  pathJ: [
    {lat: 50.162270, lng: 23.476411}, //  g2 50.162270, 23.476411
    {lat: 50.809812, lng: 23.171089}, //  g3 50.809812, 23.171089
    {lat: 51.569711, lng: 23.202186}, //  g4 51.569711, 23.202186
    {lat: 51.919092, lng: 23.774194}, //  g5 51.919092, 23.774194
    {lat: 51.596427, lng: 24.050637}, //     51.596427, 24.050637
    {lat: 50.168722, lng: 24.202782}, //     50.168722, 24.202782
  ],
  pathL: [
    {lat: 50.000824, lng: 18.085735}, // 1  50.000824, 18.085735
    {lat: 50.313055, lng: 19.096074}, //  2 50.313055, 19.096074
    {lat: 49.757249, lng: 20.560471}, //  3 49.757249, 20.560471
    {lat: 49.374879, lng: 20.489152}, //  4 49.374879, 20.489152
    {lat: 49.328422, lng: 20.270444}, //  5 49.328422, 20.270444
    {lat: 49.867699, lng: 19.549555}, //  6 49.867699, 19.549555
    {lat: 49.720377, lng: 18.579630}, //  7 49.720377, 18.579630
  ],
  pathM: [
    {lat: 49.328422, lng: 20.270444}, //  l5 49.328422, 20.270444
    {lat: 49.867699, lng: 19.549555}, //  l6 49.867699, 19.549555
    {lat: 49.720377, lng: 18.579630}, //  l7 49.720377, 18.579630
    {lat: 49.399639, lng: 18.855393}, //   8 49.399639, 18.855393
    {lat: 49.126598, lng: 20.120099}, //   9 49.126598, 20.120099
  ]
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/regions.ts